module.exports = __webpack_public_path__ + "media/src/images/site-top/illust2-5a90690b58bcbced44558aee4418a1d2.png";